import KpiBasicChartCard from "@/components/KpiBasicChartCard";
import TextLink from "@/components/Link/TextLink";
import { Box, Card, CardContent, CardHeader, Container, Divider } from "@mui/material";
import _ from "lodash";
import { useOutletContext } from "react-router-dom";

function BoxInfo(props) {
    const { label, fallback = "n/a", sx, children, ...restProps } = props;

    return (
        <Box sx={{ gridColumn: { xs: "span 12", sm: "span 6" }, ...sx }} {...restProps}>
            <Box sx={{ fontWeight: "bold", marginBottom: 0.2 }}>{label}</Box>
            <Box sx={{ marginLeft: 4 }}>{!_.isEmpty(children) ? children : fallback}</Box>
        </Box>
    );
}

export default function KpiInformation() {
    const { kpi } = useOutletContext();
    const kpiData = kpi.data?.data;
    const relations = _.sortBy(kpiData?.relations ?? [], ["type.name_display", "target.title"]);
    const groupRelations = _.groupBy(relations, ["type.name_display"]);
    const trackings = _.sortBy(kpiData?.trackings ?? [], ["trackable_type.name_display", "trackable.title"]);
    const groupTrackings = _.groupBy(trackings, ["trackable_type.name_display"]);

    return (
        <Container sx={{ marginTop: 3 }}>
            <Card variant="outlined">
                <CardHeader title="Information"></CardHeader>
                <Divider variant="middle" />
                <CardContent>
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: "repeat(12, 1fr)",
                            gap: 2,
                            marginTop: 2,
                        }}
                    >
                        <BoxInfo label="ชื่อตัวชี้วัด">{kpiData?.title}</BoxInfo>
                        <BoxInfo label="ชุดข้อมูล">
                            <Box component="ol" sx={{ margin: 0 }}>
                                {kpiData?.kpi_data_segments
                                    ?.filter((x) => x.primary == true)
                                    ?.map((dataSegment) => (
                                        <Box component="li" key={dataSegment.id} sx={{ margin: 0 }}>
                                            {dataSegment.data_segment_title} ({dataSegment.data_unit})
                                        </Box>
                                    ))}
                            </Box>
                        </BoxInfo>
                        <BoxInfo label="คำอธิบาย">{kpiData?.description}</BoxInfo>
                        <BoxInfo label="วิธีการคำนวณ">{kpiData?.data_formula}</BoxInfo>
                        <BoxInfo label="ข้อมูลที่เกี่ยวข้อง">{kpiData?.data_related}</BoxInfo>
                        <BoxInfo label="หน่วยนับ">{kpiData?.data_unit}</BoxInfo>
                        <BoxInfo label="กรอบเวลา">{kpiData?.timeframe?.title}</BoxInfo>
                        <BoxInfo label="ผู้รับผิดชอบ">
                            {
                                <Box component="ol" sx={{ margin: 0 }}>
                                    {kpiData?.stakeholder_groups?.map((group) => (
                                        <Box component="li" key={group.id} sx={{ margin: 0 }}>
                                            {group.title}
                                        </Box>
                                    ))}
                                </Box>
                            }
                        </BoxInfo>

                        <BoxInfo
                            label={`เชื่อมโยงตัวชี้วัด (${relations?.length ?? "-"})`}
                            sx={{ gridColumn: { xs: "span 12" } }}
                        >
                            {Object.entries(groupRelations)?.map(([key, relations]) => (
                                <Box key={key}>
                                    <Box sx={{ fontWeight: "bold" }}>{relations[0]?.type?.name_display}</Box>
                                    <Box component="ol" sx={{ margin: 0 }}>
                                        {relations?.map((relation) => (
                                            <Box key={relation.id} component="li" sx={{ margin: 0 }}>
                                                <TextLink
                                                    to={`/kpis/${relation.target?.id}`}
                                                    label={relation.target?.title}
                                                >
                                                    {relation.target?.title} [{relation.target?.kpi_code}]{" "}
                                                    <Box
                                                        component="span"
                                                        sx={{
                                                            color: "gray",
                                                        }}
                                                    >
                                                        #{relation.target?.id}
                                                    </Box>
                                                </TextLink>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            ))}
                        </BoxInfo>
                        <BoxInfo
                            label={`เชื่อมโยงแผน (${trackings?.length ?? "-"})`}
                            sx={{ gridColumn: { xs: "span 12" } }}
                        >
                            {Object.entries(groupTrackings)?.map(([key, trackings]) => (
                                <Box key={key}>
                                    <Box sx={{ fontWeight: "bold" }}>{trackings[0]?.trackable_type?.name_display}</Box>
                                    <Box component="ol" sx={{ margin: 0 }}>
                                        {trackings?.map((tracking) => (
                                            <Box key={tracking.id} component="li" sx={{ margin: 0 }}>
                                                <TextLink to={`#`} label={tracking.trackable?.title}>
                                                    {tracking.trackable?.title} [{tracking.trackable?.code}]{" "}
                                                    <Box
                                                        component="span"
                                                        sx={{
                                                            color: "gray",
                                                        }}
                                                    >
                                                        #{tracking.trackable?.id}
                                                    </Box>
                                                </TextLink>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            ))}
                        </BoxInfo>
                    </Box>
                </CardContent>
            </Card>

            <KpiBasicChartCard kpiId={kpiData.id} sx={{ margin: 0, padding: 0, marginTop: 3 }} />
        </Container>
    );
}
